import Paragraph from '@editorjs/paragraph';

/**
 * Paragraph with sanitizer rules that allow colored text (foreColor / span style)
 * and inline comment marks — default @editorjs/paragraph only allows <br> inside text.
 */
export default class RichParagraph extends Paragraph {
  static get sanitize() {
    return {
      text: {
        br: true,
        a: { href: true, target: true, rel: true },
        b: true,
        strong: true,
        i: true,
        em: true,
        u: true,
        mark: true,
        code: true,
        span: { style: true, class: true, 'data-doc-comment-id': true },
        font: { color: true, face: true, size: true },
      },
    };
  }
}
